import {status} from '../../../../utils/constant';

/*
{
"id": 12345,
"status": "PENDING",
"userId": "ab123-cd456-ef789-gh753",
"userFullname": "John Doe",
"invitedOrganisationCountry": "FRANCE",
"invitedOrganisationName": "ALG",
"invitedRegistrationNumber": "123456789",
"invitedVATIdentificationNumber": "FR123456789",
"invitedContactFirstName": "John",
"invitedContactLastName": "Doe",
"invitedContactEmail": "john.doe@alg.fr",
"invitedContactPhoneNumber": "+33607080910",
"invitedContactLanguage": "fr",
"customMessage": "Hello world",
"lastSentDate": "1970-07-07T12:59:00Z",
"rejectionReason": "I don't this organisation",
"resendReason": "Pretty please",
"resendable": false,
"organisationTargetId": 654321,
"token": "jsvksjgvesgegsvugksgvlgkvjsgvkguvsv",
"creationDate": "1970-01-01T12:59:00Z",
"invitingClientId" / "invitingSubcontractorId": "789456",
"invitingCountry": "FRANCE",
"sentCounter": 1
},

*/

export const suggestionsInDb = [
  {
    invitingOrganisation: {
      organisationId: 1,
      registrationNumber: '1245678945612',
      groupId: 2,
      country: 'FRANCE',
      fullName: 'ALG',
      address: {
        addressLine: '1 rue de la paix',
        city: 'LYON',
        postCode: '69003'
      },
      logo: true,
      depositor: false,
      enabled: true,
      priorAcceptation: true,
      identificationNumbers: {
        VAT_IDENTIFICATION_NUMBER: 'FR12345678912345'
      }
    },
    invitationId: 3,
    subcontractorId: 4
  }
];

export const invitationsInDb = [
  {
    id: 12345,
    userId: 'ab123-cd456-ef789-gh753',
    userFullname: 'John Doe',
    invitedOrganisationName: 'ALG',
    invitedContactEmail: 'john.doe@alg.fr',
    invitedContactFirstName: 'John',
    invitedContactLastName: 'Doe',
    customMessage: 'Hello world',
    status: status.PENDING,
    invitedContactLanguage: 'fr',
    creationDate: '1970-01-01T12:59:00Z',
    lastSentDate: '1970-07-07T12:59:00Z',
    token: 'jsvksjgvesgegsvugksgvlgkvjsgvkguvsv',
    resendable: false,

    invitedOrganisationCountry: 'FRANCE',
    invitedRegistrationNumber: '123456789',
    invitedVATIdentificationNumber: 'FR123456789',
    invitedContactPhoneNumber: '+33607080910',
    rejectionReason: "I don't this organisation",
    resendReason: 'Pretty please',
    organisationTargetId: 654321,
    invitingClientId: '789456',
    invitingSubcontractorId: '789456',
    invitingCountry: 'FRANCE',
    sentCounter: 1
  }
];
